import { render, staticRenderFns } from "./TeacherSection.vue?vue&type=template&id=d2efe432&"
import script from "./TeacherSection.vue?vue&type=script&lang=js&"
export * from "./TeacherSection.vue?vue&type=script&lang=js&"
import style0 from "./TeacherSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports